import { ScreenManager } from "divine-app-core/Screens/ScreenManager";
export const UISystem = {
    appScreen: new ScreenManager("APP"),
    appMenu: {},
    _active: true,
    get active() {
        if (this.appScreen._screenState.screen == "" ||
            this.appScreen._screenState.mode == "") {
            this._active = false;
        }
        return this._active;
    },
    set active(acitve) {
        this._active = acitve;
    },
    show(show) {
        this.active = show;
        this.appScreen.setEnabled(show);
    },
};
